<div class="bootstrap-wrapper">
    <div class="projectListReport">
        <div *ngIf="isGenerating">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
                <div class="loader-text">Loading...</div>
            </div>
        </div>
        <div class="alert alert-red is-active container" *ngIf="error">
            {{ errorMessage }}
        </div>
        <div *ngIf="reportData && reportData.projects" id="onemap-report">
            <h1>Project List Report</h1>
            <table aria-label="Project List Report">
                <thead>
                    <tr>
                        <th>Project ID</th>
                        <th>Title</th>
                        <th>Primary Improvement Type</th>
                        <th>Status</th>
                        <th>Let Indicator</th>
                        <th>Let Date</th>
                        <th>Estimated Cost for Construction</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let project of reportData.projects">
                        <td><a href="?projectId={{ project.id }}" target="blank">{{ project.id }}</a></td>
                        <td>{{ project.title }}</td>
                        <td>{{ project.improvementType }}</td>
                        <td>{{ project.status }}</td>
                        <td>{{ project.letFlag }}</td>
                        <td>{{ project.letDate }}</td>
                        <td>{{ project.estimatedConstructionCost | currency }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
